module.exports = __webpack_public_path__ + "img/light-Path 17@3x.2eda892b.png";